function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.063 7.04H3.624a.167.167 0 01-.155-.109.166.166 0 01.045-.184l5.774-5.083A.964.964 0 008.018.217L.543 6.8a1.608 1.608 0 000 2.407l7.473 6.58a.963.963 0 001.27-1.446L3.513 9.257a.168.168 0 01.11-.293h11.44a.962.962 0 000-1.925v.001z"
});

function SvgHappyPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappyPrevious;